<template>
    <div class="main">
        <div class="double-column" v-if="pcVersion">
            <div class="column">
                <perk_shop/>
                <perk_list/>
            </div>
            <div class="column">
                <how_to/>
                <monitoring/>
<!--                <personal_cabinet/>-->
                <last_buys/>
            </div>
        </div>
        <div class="single-column" v-else>
            <perk_shop/>
            <how_to/>
            <perk_list/>
            <monitoring/>
<!--            <personal_cabinet/>-->
            <last_buys/>
        </div>
    </div>
</template>

<script>
    import perk_shop from '@/components/main/perk_shop.vue'
    import how_to from '@/components/main/how_to.vue'
    import perk_list from '@/components/main/perk_list.vue'
    import monitoring from '@/components/main/monitoring.vue'
    import personal_cabinet from '@/components/main/personal_cabinet.vue'
    import last_buys from '@/components/main/last_buys.vue'
    import {mapGetters} from "vuex";

    export default {
        name: "Main",
        components: {
            perk_shop,
            how_to,
            perk_list,
            monitoring,
            /*personal_cabinet,*/
            last_buys,
        },
        computed:{
            ...mapGetters('window',['pcVersion'])
        }
    }
</script>

<style scoped lang="scss">
    .main {
        .double-column{

            display: grid;
            grid-template-columns: calc(60% - 8px) 1fr; // $spacing / 2
            grid-gap: $spacing;

            @include laptop{
                grid-template-columns: calc(55% - 8px) 1fr;

            }
            .column {
                display: flex;
                flex-direction: column;

                & > *:not(:last-child) {
                    margin-bottom: $spacing;
                }
            }
        }
        .single-column{
            display: flex;
            flex-direction: column;
            @include tablet{
                &>*{
                    margin-bottom: 16px;
                }
            }
        }

        @include mobile{
            border-radius: 32px;
            overflow: hidden;
            background: $bg_light;
            .single-column{
                &>*{
                    border-radius: 0 !important;
                    margin-bottom: 0;
                }
            }
            .tmp-block, .tmp-block-short{
                background: none;
                position: relative;
                &:not(:last-child):not(.no-line){
                    &::before{
                        content: '';
                        height: 1px;
                        position: absolute;
                        left: 24px;
                        right: 24px;
                        bottom: 0;
                        background: $bg_line;
                    }
                }
            }
        }
    }
</style>